<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :title="$t('attributes.payment')"
    size="large"
  >
    <template #body>
      <div class="flex w-full flex-col gap-2">
        <InvoiceItemEditDialogItem
          v-for="payment in invoice.payments"
          :key="payment.id"
          :payment="payment"
        />
        <div
          class="flex flex-row justify-between rounded-lg bg-primary-50 px-4 py-3 font-semibold dark:bg-slate-600"
        >
          <span class="capitalize-first">{{ $t('global.total') }}</span>
          <span>{{ $h.formatCurrency(invoice.total_paid) }}</span>
        </div>
      </div>
    </template>
    <template #footer>
      <BaseButton
        :title="$t('button.add_new_m', { var: $t('attributes.payment') })"
        icon="plus"
        color="primary"
        @click="switchToAddPayment"
      />
      <BaseButton :title="$t('button.close')" color="dark" @click="close" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapGetters } from 'vuex'

import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import InvoiceItemEditDialogItem from './InvoiceItemEditDialogItem'

export default {
  name: 'InvoicingShowPaimentsDialog',
  components: { BaseCenteredModal, InvoiceItemEditDialogItem },
  emits: ['close', 'backdropClicked', 'switchToPayment'],
  props: {
    isModalVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters({ invoice: 'invoicing/getInvoice' }),
    localIsModalOpen: {
      get() {
        return this.isModalVisible
      },
      set(value) {
        if (!value) this.close()
      }
    }
  },
  methods: {
    switchToAddPayment() {
      this.$emit('switchToPayment')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
